export type NavigationItem={title:string,path:string,access?:boolean,childrens?:NavigationItem[],icon?:string,alwaysVisibleChildren?:boolean};
export function navigationItems(links:NavigationItem[],client:{client_id?:number,type?:string}|null|undefined,path:string):NavigationItem[]{
 const administrator=client?.type==='admin';
 const catalogEditor=administrator||client?.type==='moderator';
 if(path==='/admin'||path.startsWith('/admin/'))return [
  {title:'Растения',path:'/admin/catalog/seeds',icon:'vegetables',access:catalogEditor},
  {title:'Предложения правок',path:'/admin/catalog/suggestions',icon:'edit',access:catalogEditor},
  {title:'Бренды',path:'/admin/catalog/brands',icon:'briefcase',access:administrator},
  {title:'Категории',path:'/admin/catalog/categories',icon:'fluent-emoji-high-contrast:lotus',access:administrator},
 ].filter(item=>item.access!==false);
 return [
  ...(client?.client_id?[{title:'Журнал',path:`/profiles/${client.client_id}/gardens`,icon:'journal'}]:[]),
  ...links.map(item=>item.path==='/catalog'?{...item,alwaysVisibleChildren:false,childrens:[{title:'Рейтинг растений',path:'/tops'}]}:item.path==='/feed'?{...item,alwaysVisibleChildren:false,childrens:[...(item.childrens||[]).filter(child=>child.path!=='/questions'),{title:'Вопросы и ответы',path:'/questions'}]}:item),
  {title:'Сообщества',path:'/groups',icon:'community'},
  {title:'Эксперименты',path:'/experiments',icon:'experiment'},
  ...(catalogEditor?[{title:'Админка',path:'/admin/catalog/seeds',icon:'eos-icons:admin-outlined'}]:[]),
 ];
}
export function navigationMatches(path:string,target:string){
 return path===target||(target!=='/'&&path.startsWith(target+'/'));
}
export function navigationIsBranch(items:NavigationItem[],path:string):boolean{
 return items.some(item=>item.access!==false&&((item.path===path&&!item.alwaysVisibleChildren&&!!item.childrens?.some(child=>child.access!==false))||navigationIsBranch(item.childrens||[],path)));
}
export function selectedNavigationPath(items:NavigationItem[],path:string):string|undefined{
 const candidates:string[]=[];
 const visit=(list:NavigationItem[])=>{for(const item of list){if(item.access===false)continue;if(navigationMatches(path,item.path))candidates.push(item.path);visit(item.childrens||[]);}};
 visit(items);return candidates.sort((a,b)=>b.length-a.length)[0];
}
export function visibleNavigationChildren(items:NavigationItem[],selected:string|undefined,expanded:boolean,limit=10){
 const allowed=items.filter(item=>item.access!==false);
 if(expanded||allowed.length<=limit)return allowed;
 const active=allowed.find(item=>selected&&navigationMatches(selected,item.path));
 if(active&&!allowed.slice(0,limit).includes(active))return [...allowed.slice(0,limit-1),active];
 return allowed.slice(0,limit);
}
